export type LandingPageResponseType = {
  channel_groups: ChannelsGroup[];
  genres: GenreGroupType[];
};

export type GenreGroupType = {
  channels: Channel[];
  title: string;
};

export type ChannelGenreGroupType = {
  channels: Channel[];
};

export type Channel = {
  id: string;
  name: string;
  callsign?: string;
  logo_url?: string;
};

export type ChannelsGroup = {
  title: string;
  total_channels?: number;
  span_count?: number;
  max_rows?: number;
  channels: Channel[];
  type?: string;
  labelId?: string;
};

export enum ChannelGroupTypes {
  CALLOUT = 'callout',
  CORE = 'core',
  FAST = 'fast',
  ADDONS = 'addons',
}
